import React from 'react';
import FormControlLabelContainer from './FormControlLabelContainer';
/**
 * 用于给Radio、Checkbox、Switch等组件添加上文本的组件。
 */
export default function FormControlLabel(_a) {
    var label = _a.label, control = _a.control, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'right' : _b;
    return (React.createElement(FormControlLabelContainer, { className: "sinoui-form-control-label", labelPosition: labelPosition, readOnly: control.props.readOnly },
        control,
        React.createElement("span", { className: "sinoui-form-control-label__title" }, label)));
}
//# sourceMappingURL=FormControlLabel.js.map